
import { useState, useMemo } from 'react';
import { Profile } from '@/services/userService';

export function useUserSearch(users: Profile[]) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredUsers = useMemo(() => {
    return users.filter(user => {
      const username = (user.username || '').toLowerCase();
      const query = searchQuery.toLowerCase();
      return username.includes(query);
    });
  }, [users, searchQuery]);

  const filteredAdmins = useMemo(() => 
    filteredUsers.filter(user => user.is_admin),
    [filteredUsers]
  );

  const filteredRegularUsers = useMemo(() => 
    filteredUsers.filter(user => !user.is_admin),
    [filteredUsers]
  );

  return {
    searchQuery,
    setSearchQuery,
    filteredAdmins,
    filteredRegularUsers
  };
}
